import { ColDef, ICellRendererParams } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IconName, IconSize } from '@panaya/ui/p-icon';
import { ColorName } from '@panaya/ui/styles-to-code';
import { IconTextRendererModel } from './icon-text-renderer.model';

@Component({
    selector: 'entity-icon-text-renderer',
    template: `
        <div class="icon-text-renderer" [ngClass]="{ 'right-align': iconOnRight, 'left-align': !iconOnRight }">
            <p-icon
                *ngIf="icon && !hideIcon"
                [name]="icon"
                [color]="iconColor"
                [size]="size"
                [matTooltip]="iconTooltip || tooltipValue"
                [ngClass]="{ 'right-icon': iconOnRight, clickable: iconClickable }"
                (click)="iconClicked(rowData)"
            ></p-icon>
            <p-icon-image
                *ngIf="imgIcon && !hideIcon"
                [name]="imgIcon"
                [size]="size"
                [matTooltip]="iconTooltip || tooltipValue"
                [ngClass]="{ 'right-icon': iconOnRight, clickable: iconClickable }"
                (click)="iconClicked(rowData)"
            >
            </p-icon-image>
            <span
                *ngIf="!hideText"
                [matTooltip]="tooltipValue"
                [showOnlyWhenEllipsis]="showOnlyWhenEllipsis"
                class="common-grid-cell-value"
            >
                {{ value }}
            </span>
            <span *ngIf="value === undefined && placeHolder" class="place-holder-text common-grid-cell-value"> {{ placeHolder }} </span>
        </div>
    `,
    styleUrls: ['./icon-text-renderer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconTextRendererComponent implements IconTextRendererModel {
    public value!: string;
    public icon!: IconName;
    public imgIcon?: IconName;
    public iconTooltip!: string;
    public iconColor!: ColorName;
    public size!: IconSize;
    public hideText = false;
    public tooltipValue!: string;
    public showOnlyWhenEllipsis!: boolean;
    public iconOnRight = false;
    public hideIcon = false;
    public showIconOnHover = false;
    public placeHolder!: string;
    protected rowData!: Record<string, any>;
    protected iconClicked!: (data: Record<string, any>) => void;
    protected iconClickable = false;

    agInit(params: IconTextRendererParams): void {
        const colDef = params.colDef as ColDef;
        const inputData = colDef.cellRendererParams;
        this.value = params.getValue?.();
        if (inputData?.iconsMap) {
            const technicalValue = inputData?.iconField
                ? this.getIconFieldValue(params.data, inputData.iconField)
                : params.data[colDef.field as string];
            const iconObject = inputData?.iconsMap.get(technicalValue);
            this.icon = iconObject?.icon;
            this.iconColor = iconObject?.color;
            this.size = iconObject?.size;
            this.iconTooltip = iconObject?.tooltip;
        } else {
            this.icon = inputData?.getIcon?.(params.node.data) ?? inputData?.icon;
            this.size = inputData?.iconSize;
        }
        this.showIconOnHover = params.showIconOnHover;
        this.imgIcon = params.imgIcon;
        this.placeHolder = inputData?.placeholder;
        this.hideIcon = inputData?.hideIcon ? inputData?.hideIcon(params.data) : false || this.showIconOnHover;
        this.hideText = inputData?.hideText;
        this.tooltipValue = inputData?.getTooltipValue ? inputData.getTooltipValue(params.node.data) : this.value;
        this.showOnlyWhenEllipsis = inputData?.showTooltipAlways ? !inputData.showTooltipAlways : true;
        this.iconOnRight = inputData?.iconOnRight || false;
        this.iconClickable = !!inputData?.onIconClickedFunction;
        this.iconClicked = this.iconClickable ? inputData?.onIconClickedFunction : () => {};
        this.rowData = params.data;
    }

    public refresh(params: ICellRendererParams): boolean {
        return false;
    }

    //method return field value in data object
    //field can be an hierarchy fields joined by '.'
    private getIconFieldValue(data: Record<string, any>, field: string): string {
        return field.split('.').reduce<any>((value, key) => value[key], data);
    }

    public onMouseEnter(): void {
        if (this.showIconOnHover) {
            this.hideIcon = false;
        }
    }

    public onMouseLeave(): void {
        if (this.showIconOnHover) this.hideIcon = true;
    }
}

export interface IconTextRendererParams extends ICellRendererParams {
    icon?: IconName;
    imgIcon?: IconName;
    hideIcon?: (value: boolean) => boolean;
    showIconOnHover: boolean;
}
